module.exports = __webpack_public_path__ + "static/media/52_A.867d4165.png";